"use client";

import React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { FavoritesProvider } from "./FavoritesContext";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <FavoritesProvider>
        <TooltipProvider>
          {children}
          <Toaster richColors position="top-right" closeButton />
        </TooltipProvider>
      </FavoritesProvider>
    </NextThemesProvider>
  );
}
